module.exports = __webpack_public_path__ + "static/media/no-thumbnail.fa162b7b.jpg";